import styled from 'styled-components';

export const LogoWrapper = styled.div`
  margin-left: auto;
`;
